import Select from "react-select";
import useAuth from 'hooks/useAuth';
import React, { useState } from "react";
import baseController from "api/base.controller";
import { Form, Button, InputGroup } from "react-bootstrap";

function DetailFilterFields({
  specificData,
  specificFilter,
  setSpecificFilter,
  clearFilterValues
}) {
  const { auth } = useAuth();

  const [lojaData, setLojaData] = useState([]);
  const [caixaData, setCaixaData] = useState([]);
  const [formaPagamentoData, setFormaPagamentoData] = useState([]);

  const [lojas, setLojas] = useState([]);
  const [caixas, setCaixas] = useState([]);
  const [formasPagamento, setFormasPagamento] = useState([]);

  const [loadingComboLoja, setLoadingComboLoja] = useState(false);
  const [loadingComboCaixa, setLoadingComboCaixa] = useState(false);
  const [loadingComboFormaPagamento, setLoadingComboFormaPagamento] = useState(false);

  const handleLoadCombo = async (type) => {
    var response;

    switch(type) {
      case 0:
        if (lojaData.length === 0) {
          setLoadingComboLoja(true);
          response = await callEndpoint(type);

          setLojaData(old => {
            var newValue  = [...old];

            response.data?.forEach(loja => {
              newValue.push({
                value: loja.id,
                label: loja.nome
              });
            });

            setLojas(newValue.filter(v => specificFilter.lojasId.includes(v.value)));

            return newValue;
          });

          setLoadingComboLoja(false);
        }

        break;
      case 1:
        if (caixaData.length === 0) {
          setLoadingComboCaixa(true);
          response = await callEndpoint(type);

          setCaixaData(old => {
            var newValue  = [...old];

            response.data?.forEach(caixa => {
              newValue.push({
                value: caixa.id,
                label: caixa.nome
              });
            });

            setCaixas(newValue.filter(v => specificFilter.caixasId.includes(v.value)));

            return newValue;
          });

          setLoadingComboCaixa(false);
        }

        break;
      case 2:
        if (formaPagamentoData.length === 0) {
          setLoadingComboFormaPagamento(true);
          response = await callEndpoint(type);

          setFormaPagamentoData(old => {
            var newValue  = [...old];

            response.data?.forEach(formaPagamento => {
              newValue.push({
                value: formaPagamento.id,
                label: formaPagamento.nome
              });
            });

            setFormasPagamento(newValue.filter(v => specificFilter.formasPagamentoId.includes(v.value)));

            return newValue;
          });

          setLoadingComboFormaPagamento(false);
        }
        
        break;
    }
  };

  const callEndpoint = async (type) => {
    return await baseController.get(`Evento/GetFilter/${specificData?.eventoId ?? ""}/${type}`, {
      headers: {
        'Authorization': auth.token ?? JSON.parse(localStorage.getItem('auth')).token
      }
    });
  };

  const handleSpecificFilter = (event, type = null) => {
    const newFilter = {...specificFilter}

    switch(type) {
      case "number": {
        const value =  parseFloat(event.target.value);
        newFilter[event.target.name] = value;

        break;
      }
      default: {
        newFilter[event.target.name] = event.target.value;

        break;
      }
    }

    setSpecificFilter(newFilter);
  };

  useState(async () => {
    if (specificFilter.lojasId.length > 0)
      await handleLoadCombo(0);

    if (specificFilter.caixasId.length > 0)
      await handleLoadCombo(1);

    if (specificFilter.formasPagamentoId.length > 0)
      await handleLoadCombo(2);
  }, []);

  const doClearFilters = () => {
    clearFilterValues();

    setLojas([]);
    setCaixas([]);
    setFormasPagamento([]);
  };

  return (
    <>
      <Form>
        <Form.Group 
          controlId="formLojasId"
          className="mb-3 form-group-select-with-button"
        >
          <Form.Label>Lojas</Form.Label>
          <Select
            isMulti
            value={lojas}
            name="lojasId"
            options={lojaData}
            closeMenuOnSelect={false}
            isLoading={loadingComboLoja}
            classNamePrefix="react-select"
            placeholder="Selecione as lojas"
            onMenuOpen={() => handleLoadCombo(0)}
            onChange={(value) => {
              setLojas(value);

              var newData = { ...specificFilter };
              newData.lojasId = value.map(selected => { return selected.value });

              setSpecificFilter(newData);

              return value;
            }}
          />
        </Form.Group>
        <Form.Group 
          controlId="formCaixasId"
          className="mb-3 form-group-select-with-button"
        >
          <Form.Label>Caixas</Form.Label>
          <Select
            isMulti
            value={caixas}
            name="caixasId"
            options={caixaData}
            closeMenuOnSelect={false}
            isLoading={loadingComboCaixa}
            classNamePrefix="react-select"
            placeholder="Selecione os caixas"
            onMenuOpen={() => handleLoadCombo(1)}
            onChange={(value) => {
              setCaixas(value);

              var newData = { ...specificFilter };
              newData.caixasId = value.map(selected => { return selected.value });

              setSpecificFilter(newData);

              return value;
            }}
          />
        </Form.Group>
        <Form.Group 
          controlId="formFormasPagamentoId"
          className="mb-3 form-group-select-with-button"
        >
          <Form.Label>Formas de Pagamento</Form.Label>
          <Select
            isMulti
            value={formasPagamento}
            name="formasPagamentoId"
            closeMenuOnSelect={false}
            options={formaPagamentoData}
            classNamePrefix="react-select"
            onMenuOpen={() => handleLoadCombo(2)}
            isLoading={loadingComboFormaPagamento}
            placeholder="Selecione as formas de pagamento"
            onChange={(value) => {
              setFormasPagamento(value);

              var newData = { ...specificFilter };
              newData.formasPagamentoId = value.map(selected => { return selected.value });

              setSpecificFilter(newData);

              return value;
            }}
          />
        </Form.Group>
        <Form.Group
          className="mb-3"
          controlId="formGroupPreco"
        >
          <Form.Label>Valor</Form.Label>
          <InputGroup>
            <InputGroup.Text>R$</InputGroup.Text>
            <Form.Control
              name="valor"
              type="number"
              placeholder="0,00"
              value={specificFilter.valor}
              onChange={(e) => handleSpecificFilter(e, 'number')}
            />
          </InputGroup>
        </Form.Group>
        <Form.Group controlId="formGroupData">
          <Form.Label>Data</Form.Label>
          <InputGroup>
            <InputGroup.Text>De</InputGroup.Text>
            <Form.Control
              required
              type="date"
              placeholder=""
              name="dataInicial"
              value={specificFilter.dataInicial}
              selected={specificFilter.dataInicial}
              onChange={(e) => handleSpecificFilter(e)}
            />
          </InputGroup>
          <InputGroup className='filter-final-date'>
            <InputGroup.Text>Até</InputGroup.Text>
            <Form.Control
              required
              type="date"
              placeholder=""
              name="dataFinal"
              value={specificFilter.dataFinal}
              selected={specificFilter.dataFinal}
              onChange={(e) => handleSpecificFilter(e)}
            />
          </InputGroup>
        </ Form.Group>
        <Form.Group controlId="formGroupTipoEvento">
          <Form.Label>Tipo do Pedido</Form.Label>
          <Form.Select
            name="tipoPedido"
            aria-label="Tipo do Pedido"
            value={specificFilter.tipoPedido}
            onChange={(e) => handleSpecificFilter(e)}
          >
            <option value=""></option>
            <option value="C">Compra</option>
            <option value="E">Estorno</option>
            <option value="X">Cancelamento</option>
          </Form.Select>
        </Form.Group>
      </Form>

      <Button
        variant='any'
        title='Limpar Filtros'
        onClick={doClearFilters}
        style={{ border: "1px solid black", position: "absolute", bottom: 15, left: 15 }}
        className='filter-bar-footer-button'
      >
        Limpar
      </Button>
    </>
  )
}

export default React.memo(DetailFilterFields);